<template>
  <div>
    <div class="PCshare" :style="{backgroundColor:PCcolor}">
      <img :src="PCimg" alt="" class="pcimage">
      <div class="inpbox">
        <div class="inp">
          <el-input oninput="value=value.replace(/\D/gi,'')" placeholder="请输入您的手机号码" v-model="phone" maxlength="11"
                    class="wp-input input-with-select">
            <el-select v-model="countryIndex" slot="prepend" style="width: 100px" :disabled="true">
              <div class="el-input_search">
                <img src="../assets/search.svg" />
                <input type="text" :placeholder="$t('signIn.searchArea')" class="el-input__inner">
              </div>
              <el-option v-for="(item, index) in countries" :label="`+${item.country_code} `" :key="item.id"
                         :value="item.id">
                <span>+{{ item.country_code }} </span>
              </el-option>
            </el-select>
          </el-input>
          <el-input maxlength="6" :placeholder="$t('Verification code')" v-model="verification"
                    oninput="value=value.replace(/\D/gi,'')" class="wp-input input-with-send" style="margin-top: 15px">
            <el-button slot="append" @click="countDown" style="background-color: #ff904d;color: #fff;padding: 13px 20px;">
              <span v-if="maxTotaltime == setTime"> {{ $t('Send') }} </span>
              <span v-else>{{ setTime }} s </span>
            </el-button>
          </el-input>
          <el-button class="submit" @click="onsubmit">立即领取</el-button>
        </div>
      </div>
    </div>
    <!--  H5  -->
    <div class="shareRegister">
      <img :src="H5img" alt="">
<!--      :style="{background:color}"-->
      <div class="inpbox" >
        <div class="inp">
          <el-input oninput="value=value.replace(/\D/gi,'')" placeholder="请输入您的手机号码" v-model="phone" maxlength="11"
            class="wp-input input-with-select">
            <el-select v-model="countryIndex" slot="prepend" style="width: 60px" :disabled="true">
              <div class="el-input_search">
                <img src="../assets/search.svg" />
                <input type="text" :placeholder="$t('signIn.searchArea')" class="el-input__inner">
              </div>
              <el-option v-for="(item, index) in countries" :label="`+${item.country_code} `" :key="item.id"
                :value="item.id">
                <span>+{{ item.country_code }} </span>
              </el-option>
            </el-select>
          </el-input>
          <el-input maxlength="6" :placeholder="$t('Verification code')" v-model="verification"
            oninput="value=value.replace(/\D/gi,'')" class="wp-input input-with-send" style="margin-top: 15px">
            <el-button slot="append" @click="countDown" style="background-color: #ff904d;color: #fff;padding: 13px 20px;">
              <span v-if="maxTotaltime == setTime"> {{ $t('Send') }} </span>
              <span v-else>{{ setTime }} s </span>
            </el-button>
          </el-input>
          <el-button class="submit" @click="onsubmit">立即领取</el-button>
        </div>
      </div>
      <div :style="{background:color}" style="height: 250px"></div>
    </div>
  </div>
</template>
<script>
import { setStore, getStore, keys } from '@/store';
export default {
  name: 'shareRegister',
  data() {
    return {
      countries: [{
        country_code: '86',
        name: '中国',
        id: 2
      }],
      phone: '',
      countryIndex: 2,
      showButton: false,
      scrollPosition: 0,
      invite_code: '',
      imgList: [],
      color: null,
      // 验证码倒计时
      maxTotaltime: 60,
      setTime: 60,
      timer: null,
      verification: '',
      PCcolor:'',
      PCimg:'',
      H5img:'',
      id:''
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.invite_code = this.$route.query.invite_code
    this.id = this.$route.query.id
    // this.getImg()
    this.getPCImg()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 倒计时
    setCount(setTime) {
      if (setTime >= 0) {
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.setTime > 0 && this.setTime <= this.maxTotaltime) {
              this.setTime--
            } else {
              clearInterval(this.timer)
              this.timer = null
              this.setTime = 60
            }
          }, 1000)
        }
      }
    },
    countDown() { //发送验证码
      if (!this.phone) {
        this.$message({
          message: this.$t('errorprompt.phoneEmpty'),
          type: 'warning'
        })
        return false
      }
      if (this.maxTotaltime == this.setTime) {
        this.$http.post('/api/checkUser', {
          mobile: this.phone,
          country_code: '86'
        }).then((body) => {
          if (body.data.code == 200) {
            if (body.data.data.is_exist == 0) {
              this.$message({
                message: this.$t('User Does Not Exist'),
                type: 'warning',
                customClass: 'messageclass',
                //   center: true
              });
              return false
            }
            this.$http.post('/api/login/verify-code', {
              mobile: this.phone,
              length: 6,
              country_code: '86'
            }).then((res) => {
              if (res.data.code == 200) {
                this.setCount(this.setTime)
                console.log(res)

              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'warning'
                })
              }
            }).catch((error) => {
              console.log(error) // 请求失败返回的数据
            })
            // this.code = res.data.data.code
          }
        })
      }
    },
    getPCImg() {
      let id = this.id ? this.id : 1
      this.$http.get('/api/getPagePoster?id=' + id).then((res) => {
        this.PCimg = res.data.data.pc_img
        this.PCcolor = res.data.data.background_color
        this.H5img = res.data.data.mobile_img
      })
    },
    getImg() {
      this.$http.get('/api/getShareImg').then((res) => {
        this.imgList = res.data.data.list
        this.color = res.data.data.colour
      })
    },
    handleScroll() {
      this.scrollPosition = window.scrollY
      this.showButton = this.scrollPosition > 500 // 300px时显示按钮
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      })
    },
    // 国家区号
    toLog(user_sn) {
      this.$http.post('/api/addCheckPointsLog',
        { type: 3, user_sn: user_sn, value: 'landingpage-id:12' }).then((res) => {
          this.qvhao = res.data.data
          this.areaCodeData = res.data.data
          setStore(keys.areaCodeList, res.data.data)
        })
    },
    onsubmit() {
      this.$http.post('/api/signUpUser', {
        'mobile': this.phone,
        'country_code': '86',
        verification: this.verification,
        code: this.verification,
        'child_nickname': '',
        'email': '',
        'wechat_id': '',
        'landingpage_id': 12,
        'captcha': '',
        ...this.$route.query,
      }).then((res) => {
        this.input = ''
        if (res.data.code == 200) {
          this.toLog(res.data.data.user_sn)
          setStore(keys.userInfo, res.data.data);
          this.$router.push({ path: '/salecard', query: { invite_code: res.data.data.invite_code } })
          // setTimeout(() => {
          //   // window.location.href = res.data.data.url
          //   this.$router.push({ path: '/salecard' ,query:{invite_code:this.invite_code}})
          // }, 1000);
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
/* 小屏幕设备（例如手机） */
@media (max-width: 1200px) {
  .PCshare{
    display: none;
  }
  /deep/.el-input-group__append,
  .el-input-group__prepend {
    border: none;
  }

  .shareRegister {
    position: relative;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }

    .inpbox {
      padding: 1rem;
      z-index: 1;
      position: fixed;
      bottom: 0;
      .inp {
        background-color: #fff;
        border-radius: 1rem;
        padding: 1.2rem;
        box-shadow: 0 0px 10px 5px rgba(0, 0, 0, .1);
      }

      .submit {
        display: block;
        margin: 1rem auto 0;
        height: 55px !important;
        width: 100%;
        height: 2.63rem;
        background-size: contain;
        font-size: 1rem;
        color: #fff;
        background-color: #ff904d;
        border-radius: 2.2rem;
      }

      /deep/.el-input--suffix .el-input__inner {
        padding-right: 0px !important;
        background-color: #fff !important;
        border: none;
      }

      /deep/.el-input-group__prepend {
        border: none !important;
        border-right: 1px solid #bbb !important;
      }

      /deep/.el-input__inner {
        border: none !important;
      }

      /deep/.el-input--suffix .el-input__suffix {
        display: none !important;
      }

      .wp-input {
        border: 1px solid #bbb;
        border-radius: 2rem;
        overflow: hidden;
      }
    }

    .submit2 {
      position: fixed;
      bottom: 2.5rem;
      height: 55px !important;
      z-index: 999;
      display: block;
      margin: 1rem auto 0;
      width: 90%;
      left: 1rem;
      height: 2.63rem;
      background-size: contain;
      font-size: 1rem;
      color: #fff;
      background-color: #ff904d;
      border-radius: 2.2rem;
      border-color: #ff904d;
    }
  }
}

/* 大屏幕设备（例如桌面显示器） */
@media (min-width: 1200px) {
  .shareRegister{
    display: none;
  }
  .PCshare{
    position: relative;
    text-align: center;
    min-height: 100vh;
    .pcimage{
      width: 1200px;
      display: block;
      margin: 0 auto;
    }
  }
  .inpbox{
    position: absolute;
    top: 170px;
    right: 50%;
    margin-right: -540px;
    width: 386px;
    height: auto;
    border-radius: 16px;
    padding: 32px;
    background: #FFFFFF;
    box-shadow: 0 0px 15px -3px rgba(16, 24, 40, .1), 0 4px 6px -4px rgba(16, 24, 40, .1);
  }
  .submit{
    width: 100%;
    margin-top: 16px;
    background-color: #FF904D;
    color: #fff;
  }
  .submit:hover{
    //color: #FF904D;
    background: rgba(255, 144, 77, 0.5);
  }
}








</style>



// WEBPACK FOOTER //
// src/components/shareRegister.vue